export default __webpack_public_path__ + "static/media/icon1.065cf633.png";